

import "core-js";
import Base from "./base/base";
import Cookie from "hd-cookie";
import WebStorageCache from "web-storage-cache";
import API from "./API/index";

import BrowserCore from "./browser/browserCore";
import Screen from "./screen/screen";
import Dpr from "./dpr";

import BrowserInfo from "./base/browserBaseInfo";

import {useTime, useTimeAjax} from "./useTime/useTime";

import handleAjaxLimit from "./utils/handleAjaxLimit";
import getGray from "./utils/gray";

// import Vconsole from "vconsole";
// new Vconsole() ;

const newCookie = new Cookie() ;
const wsCache = new WebStorageCache()

// 统计使用时长的系统列表，后期从服务端获取
let systemArr = ["7633befa08e2db4ac4", "854294f057e46ff9bb"]
let city = newCookie.getCookie("city") || "" ;
class Kshi extends Base{
  constructor(options){
    super(options)
    // let kshiGray = grayscaleUser(0) ;
    // this.init() ;
    const { system_key = "", gray = 0.1 } = options || {} ;
    this.system_key = system_key ;
    this.gray = gray ;
  }
  init(){
    if(window.requestIdleCallback){
      requestIdleCallback(this.myNonEssentialWork, { timeout: 5000 });
    }else{
      this.dataUpload() ;
    }
  }

  myNonEssentialWork = (deadline) => {
    // 帧内有富裕时间，或者超时了，超时时间在注册函数的时候添加，此示例是5000毫秒
    if(deadline.timeRemaining() > 10 || deadline.didTimeout){
      // 代码执行了
      this.dataUpload() ;
    }else{
      requestIdleCallback(this.myNonEssentialWork);
    }
  }

  dataUpload(){
    let uid = newCookie.getCookieName("PPU", "UID") ;
    if(!uid)return null ;
    // this.useTimeDataUpload() ;
    this.browserUpload() ;
  }

  //用户使用时长数据上报
  async useTimeDataUpload(){
    try {
      let result = await useTimeAjax(this.system_key) ;
      let isGray = getGray(this.gray) ;
      if(isGray && systemArr.indexOf(this.system_key) !== -1){
        useTime(this.system_key, city);
      }
    } catch (error) {
      
    }
  }

  // 浏览器基本信息数据上报
  browserUpload(){
    let { bcName, bcVersion } = BrowserCore.getBrowserCoreInfo() || {} ;
    let { width, height } = Screen.getScreenPixel() || {} ;
    let dpr = Dpr.getDpr() || {} ;
    let userAgent = window.navigator.userAgent ;

    function crtTimeFtt() {
      var date = new Date();
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
     }

    // 新版获取用户信息方法
    let { browserName, version, os, osVersion, deviceName } = BrowserInfo || {} ;
    let params = {
      system_key: this.system_key, 
      bname: browserName || "其它",
      bversion: version || "未知",
      bcname: bcName, 
      bcversion: bcVersion, 
      swidth: width, 
      sheight: height, 
      computer_name: os || "其它", 
      computer_version: osVersion || "未知",
      deviceType: deviceName || "未知",
      dpr,
      userAgent,
      city
    }

    // 检查缓存是否已上报
    let borwserInfo = wsCache.get("browserInfo") ;
    let borwserInfo_date = wsCache.get("browserInfo_date") ;
    let result = this.contrastObj(borwserInfo, params) ;
    // if(result && borwserInfo_date === crtTimeFtt()) {
    //   return null ;
    // }

    // 高峰时间段限流
    let flag = handleAjaxLimit(5);
    if(!flag) return null;
    if(!result){
      // 上传到服务器
      API.setBrowserInfo(params)
      .then((res)=>{
        wsCache.set("browserInfo", params) ;
        wsCache.set("browserInfo_date", crtTimeFtt()) ;
        // console.log("数据存储成功", res) ;
      })
      .catch((err)=>{
        // console.log("数据存储失败")
      })
    }else if(borwserInfo_date !== crtTimeFtt()){
      // 修改时间
      API.setBrowserInfoDate({system_key: this.system_key})
      .then((res) => {
        wsCache.set("browserInfo_date", crtTimeFtt()) ;
      })
      .catch(() => {

      })
    }

  }

}

// new Kshi().init() ;
window.Kshi = Kshi ;
